module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/vinyl-69c753a541f1298bd74c578a3df51fc9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/vinyl.svg
// module id = 81OB
// module chunks = 24